import { DynamicStringSchema, ActionSchema } from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { FileArtifactCard } from './FileArtifactCard';

interface ResolvedProps {
  readonly filename: string;
  readonly downloadUrl: string;
  readonly sizeLabel?: string;
  readonly onDownload?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const schema = defineA2uiComponentSchema({
  filename: DynamicStringSchema,
  downloadUrl: DynamicStringSchema,
  sizeLabel: DynamicStringSchema,
  onDownload: ActionSchema,
}) as any;

export const FileArtifactCardImpl = createComponentImplementation(
  { name: 'FileArtifactCard', schema },
  // The authed download is host-specific, so it rides the action channel like
  // every other surface: the agent binds the `onDownload` event (with the
  // download URL + filename in its context) and the console's onA2UIAction
  // performs the fetch. See EmailComposer's onSend/onCopy for the same shape.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({
    props,
  }: Readonly<{ props: ResolvedProps; buildChild: any; context: any }>) => (
    <FileArtifactCard
      filename={props.filename ?? ''}
      downloadUrl={props.downloadUrl ?? ''}
      sizeLabel={props.sizeLabel}
      onDownload={props.onDownload}
    />
  )
);
